export { default } from './SliderModal';
